import {faClock} from '@fortawesome/pro-solid-svg-icons';

import {Icon} from '../../components/Icon/Icon';
import {FloatingList} from '../../_old/styled/internals';

type Props = {
  isRecent?: boolean;
  children: React.ReactNode;
  onMouseDown: (e: React.MouseEvent) => void;
};
export function SearchItem(props: Props): React.JSX.Element {
  return (
    <FloatingList.ListItem {...props} role="option">
      {props.isRecent && <Icon icon={faClock} size="xs" />}
      {props.children}
    </FloatingList.ListItem>
  );
}
